<div cdkTrapFocus [cdkTrapFocus]="isSelected" *ngIf="isVisible()" class="facet-group" [ngClass]="{show: isSelected }">
  <h4 class="facet-title"><a (click)="facetTitleSelect($event)" class="dialog-title-link">{{ facet.title }}</a>
    <a class="dialog-back" (click)="facetBack($event)"><span class="sr-only">Go back</span> ❮ </a>
    <a class="dialog-close" (click)="facetDialogClose($event)">
      <span class="sr-only">Close {{ facet.title }} options</span> <i class="fa fa-remove"></i>
    </a>
  </h4>
  <div *ngIf="isSelected && !facet.isBool" class="form-group form-group-refine-facets">
    <label for="refineFacets" class="sr-only">Filter Options</label>
    <input class="form-control" name="refineFacets" placeholder="Search for an option"
      (keyup)="handleRefineFacetKeyup($event)" />
  </div>

  <div class="facet-options">
    <div *ngIf="getDisplayedFacetOptions().length > 0">
      <div *ngFor="let s of getDisplayedFacetOptions()" class="checkbox">
        <label>
          <input [disabled]="isLocked(s)" type="checkbox" [checked]="isFacetSelected(s)" name="filter_{{s.field}}"
            (click)="facetClick(s);" value="{{ s.lookupValue }}"> {{ s.value }} <small
            class="text-muted">({{ s.numberOfResults }})</small>
        </label>
      </div>
    </div>
    <div *ngIf="getDisplayedFacetOptions().length == 0">
      <label>No options match filter</label>
    </div>
  </div>
  <a (click)="facetTitleSelect($event)" *ngIf="limitOptions && facet.currentOptions.length > 5" class="see-all-facets">+
    See all {{ facet.title }}
    options
  </a>
</div>
<div *ngIf="isSelected" class="dialog-backdrop"></div>